import { render, staticRenderFns } from "./tabTradeCommission.vue?vue&type=template&id=d6579040&"
import script from "./tabTradeCommission.vue?vue&type=script&lang=js&"
export * from "./tabTradeCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6579040')) {
      api.createRecord('d6579040', component.options)
    } else {
      api.reload('d6579040', component.options)
    }
    module.hot.accept("./tabTradeCommission.vue?vue&type=template&id=d6579040&", function () {
      api.rerender('d6579040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabTradeCommission.vue"
export default component.exports